export const temporaryQueryConstructor = (array: any[]) => {
  return array.join(" OR ");
};
